const classEnroll = {
  path: 'classEnroll',
  props: true,
  component: resolve => require(['../../../../../components/pages/student_user/homeClass/classEnroll'], resolve)
}
export default classEnroll



// WEBPACK FOOTER //
// ./src/router/pages/student_user/homeClass/classEnroll/index.js